export default {"src":"/_next/static/media/square-confirm.29925a10.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};